import * as S from "@styles/components/TableViewStyle";
import CTable from "@components/Common/CTable/CTable";
import { TableColumnTypes } from "@typedef/components/Common/CTable/table.column.types";

type Props = {
  columns: TableColumnTypes[];
  tableData: any;
  insertBoardCategory: () => void;
  updateBoardCategory: (idx?: number) => void;
  deleteBoardCategory: () => Promise<void>;
};
const BoardCategory = ({
  columns,
  tableData,
  insertBoardCategory,
  updateBoardCategory,
  deleteBoardCategory,
}: Props) => {
  return (
    <S.Main>
      <S.TopBtns>
        <h3>전체 {tableData.length}</h3>
        <S.Btns>
          <S.Btn type="button" onClick={insertBoardCategory} className="active">
            게시판등록
          </S.Btn>
          <S.Btn type="button" onClick={() => updateBoardCategory()}>
            수정
          </S.Btn>
          <S.Btn type="button" onClick={deleteBoardCategory}>
            삭제
          </S.Btn>
        </S.Btns>
      </S.TopBtns>
      <CTable columns={columns} tableData={tableData} />
    </S.Main>
  );
};

export default BoardCategory;
